import * as React from 'react';

import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import Retracked from 'js/lib/retracked';

type PropsToComponent = {
  children?: JSX.Element;
  csrfToken?: string;
  requestCountryCode?: string;
};

export const DirectoryApp = ({ children }: PropsToComponent) => {
  return <div className="rc-DirectoryApp">{children}</div>;
};

export default compose<PropsToComponent, {}>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'directory_graphql',
        page: 'directory_graphql',
      },
    };
  }),
  connectToStores<PropsToComponent, {}>(['ApplicationStore'], (context, props) => {
    return {
      ...props,
      csrfToken: context.ApplicationStore.getState().csrfToken,
      requestCountryCode: context.ApplicationStore.getState().requestCountryCode,
    };
  })
)(DirectoryApp);
